// 此文件由 json_to_games.py 自动生成
// 生成时间: 2025-03-25 22:23:02

export default {
  "id": "unicycle-balance-3d",
  "slug": "unicycle-balance-3d",
  "publisher": "GoGameVault",
  "thumbnail": "https://img.gamedistribution.com/514bef3fb3964d7185a8a0133e836dd8-512x384.jpg",
  "gameUrl": "https://html5.gamedistribution.com/514bef3fb3964d7185a8a0133e836dd8/",
  "releaseDate": "2025-03-25",
  "rating": 4.5,
  "plays": 0,
  "isNew": true,
  "isPopular": false,
  "isRecommended": false,
  "i18n": {
    "en": {
      "title": "Unicycle Balance 3D",
      "description": "Balance, Pedal & Survive.\n\nEnter the wacky and challenging world of Unicycle Balance 3D, a physics-based balancing game that tests your skill, patience, and reflexes! Guide your unicyclist across surreal landscapes, avoiding obstacles and mastering the delicate art of staying upright.",
      "instructions": "Left & Right Arrow, OR A and D keys",
      "genres": [
        "Agility",
        "Casual"
      ],
      "tags": [
        "balance",
        "bicycle",
        "bike",
        "bmx",
        "run"
      ]
    },
    "zh-CN": {
      "title": "三轮车平衡3D",
      "description": "平衡、踏板与生存。\n\n进入充满疯狂与挑战的3D独轮车平衡世界，一款基于物理平衡的技能考验游戏！引导你的独轮车手穿越超现实景观，避开障碍，掌握保持平衡的精细艺术。",
      "instructions": "左右箭头键，或 A 和 D 键",
      "genres": [
        "敏捷度",
        "休闲"
      ],
      "tags": [
        "平衡",
        "自行车",
        "单车",
        "BMX",
        "跑步"
      ]
    },
    "zh-TW": {
      "title": "單輪平衡 3D",
      "description": "平衡、踏板與存活。\n\n進入瘋狂挑戰的單腳車平衡3D世界，一款基於物理平衡的遊戲，考驗你的技巧、耐心和反應！引導你的單腳車騎士穿越超現實風光，避開障礙，精通保持平衡的微妙藝術。",
      "instructions": "左箭頭與右箭頭，或按鍵 A 和 D",
      "genres": [
        "敏捷性",
        "休闲"
      ],
      "tags": [
        "平衡",
        "自行車",
        "單車",
        "BMX",
        "跑步"
      ]
    },
    "zh-HK": {
      "title": "單輪平衡3D",
      "description": "平衡、踏板、求生存。\n\n進入狂野挑戰的Unicycle Balance 3D奇幻世界，一款基於物理平衡的遊戲，考驗你的技巧、耐心和反應！引導你的單輪自行車運動員穿越超現實的景觀，避開障礙，並精通保持平衡的微妙藝術。",
      "instructions": "左向及右向箭頭，或按A及D鍵",
      "genres": [
        "靈敏度",
        "休闲"
      ],
      "tags": [
        "平衡",
        "單車",
        "自行車",
        "BMX",
        "跑步"
      ]
    },
    "ja": {
      "title": "自転車バランス3D",
      "description": "バランス、ペダル、生き延びろ。\n\n物理の法則に基づいたバランス試練の世界、Unicycle Balance 3Dに飛び込み、あなたのスキル、忍耐力、反応速度を試してみましょう！サイクリストを超現実的な風景を通して導き、障害物を避け、直立不動の技術をマスターしてください！",
      "instructions": "左右矢印、またはAとDキー",
      "genres": [
        "アギリティ",
        "カジュアル"
      ],
      "tags": [
        "バランス",
        "自転車",
        "バイク",
        "BMX",
        "ラン"
      ]
    },
    "ko": {
      "title": "삼차원 한바퀴 균형",
      "description": "균형, 페달, 생존.\n\nUnicycle Balance 3D의 환상적인 도전적인 세계로 들어가세요. 이 물리 기반 균형 맞추기 게임은 당신의 기술, 성장심, 반응 속도를 테스트합니다! 우주 타기 선수를 이상한 풍경지를 지나가며 장애물을 피하고 직립된 상태를 유지하는 예술을 완성하세요!",
      "instructions": "왼쪽 및 오른쪽 방향키, 또는 A와 D 키",
      "genres": [
        "약간의 신속함",
        "일상적"
      ],
      "tags": [
        "균형",
        "자전거",
        "자전거",
        "BMX",
        "달리기"
      ]
    },
    "fr": {
      "title": "Équilibre à Vélo à une roue 3D",
      "description": "Équilibre, Pédales & Survivre.\n\nPlongez dans le monde déjanté et défiant d'Unicycle Balance 3D, un jeu de balance basé sur la physique qui met à l'épreuve votre habileté, votre patience et vos réflexes ! Guidez votre cycliste à vélo unique à travers des paysages surréalistes, évitez les obstacles et maîtrisez l'art délicat de rester debout.",
      "instructions": "Flèches Gauche et Droite, OU touches A et D",
      "genres": [
        "Agilité",
        "Loisir"
      ],
      "tags": [
        "équilibrage",
        "vélo",
        "vélo",
        "BMX",
        "course"
      ]
    }
  }
};
